import { isDefined } from '@sama/js-core';
import { get } from 'lodash';
import { selectionToArray } from '../../cross-team-shared/misc-utils';
import { interpolateLocation } from '../utils/point-cloud-interpolation-helper';
import { hasMainRendererLayer } from '../utils/shape-visibility-utils';
import { PointCloudContentState } from './point-cloud-content-state';

export function getFocusedShapeIndex(state: PointCloudContentState) {
  const { selection } = state.render;
  const selectedIndexes = selectionToArray(selection);
  return selectedIndexes.length === 1 ? selectedIndexes[0] : undefined;
}

export function isFocusedCuboidVisible(state: PointCloudContentState) {
  const focusedCuboid = getFocusedCuboid(state);

  return focusedCuboid ? hasMainRendererLayer(focusedCuboid, state) : false;
}

export function getFocusedCuboidLocation(state: PointCloudContentState) {
  const focusedCuboid = getFocusedCuboid(state);
  if (!focusedCuboid) {
    return undefined;
  }

  const { frameNumber } = state.render;
  return interpolateLocation(focusedCuboid.key_locations, frameNumber);
}

export function getVisibleFocusedCuboidLocation(state: PointCloudContentState) {
  const focusedCuboidLocation = getFocusedCuboidLocation(state);
  return focusedCuboidLocation && isFocusedCuboidVisible(state)
    ? focusedCuboidLocation
    : undefined;
}

export function getInProgressCuboidLocation(state: PointCloudContentState) {
  const { inProgressCuboid } = state.render;
  if (!inProgressCuboid) {
    return undefined;
  }

  return inProgressCuboid.key_locations[0];
}

function getFocusedCuboid(state: PointCloudContentState) {
  const { cuboids } = state.render;
  const focusedShapeIndex = getFocusedShapeIndex(state);
  return isDefined(focusedShapeIndex)
    ? get(cuboids, focusedShapeIndex)
    : undefined;
}
